import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'iv-date-ag-grid',
  templateUrl: './date-ag-grid.component.html',
  styleUrls: ['./date-ag-grid.component.scss']
})
export class DateAgGridComponent implements ICellRendererAngularComp {

  dateValue: string;
  isClosed: boolean;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.isClosed = this.router.url.includes('closed');
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    if (params) {
      const rowData = params.data;

      // INFO: status_name is only used in the landing page (Invoice Grid Component)
      if (rowData && rowData.status_name) {
        switch (rowData.status_name.toLowerCase().trim()) {
          case 'invoiced':
            this.dateValue = this.formatDate(rowData.invoiced_date,rowData);
            break;
          case 'pending approval':
            this.dateValue = this.formatDate(rowData.submitted_date,rowData);
            break;
          default:
            this.dateValue = this.formatDate(rowData.date,rowData);
            break;
        }
      } else {
        this.dateValue = this.formatDate(params.value,rowData);
      }
    }
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  formatDate(inputDate: string,rowData): string {
    if (!inputDate) return '';
    if (this.isClosed) {
      if (rowData && rowData?.type === 'invoice') {
          return moment(inputDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      } else {
        return moment(inputDate, 'YYYY-MM-DD').format('DD/MM/YYYY');  
      }
    }else{
      return moment(inputDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  }

}